export default __webpack_public_path__ + "static/media/video.0e8332af.mp4";